module.exports = "/_next/static/images/num-4-8ed0b5e9.png";